import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const titleStyle = css`
  font-weight: ${theme.font.weight.bold};
`;
